module.exports = __webpack_public_path__ + "img/gbwhatsapp-screen-4.7d8172e6.webp";